import About from './components/About/';
import Spinner from '../../../../../../components/Spinner/';

import React from 'react';
import { graphql, compose } from 'react-apollo';
import gql from 'graphql-tag';

const AboutUserData = gql`
query {
  AdvisorProfile: viewer {
    id
    first_name
    avatar: photo
    biography
    last_name
    phone
    email
    linkedin_username
    paypal_email
    donation_details
  }
}
`;

const SubmitAboutData = gql`
mutation SubmitAboutData(
  $first_name: String
  $last_name: String
  $phone: String
  $email: String
  $avatar: String
  $linkedin_username: String
  $paypal_email: String
  $donation_details: String
  $biography: String
) {
  updateUser(input: {
    first_name: $first_name
    last_name: $last_name
    phone: $phone
    email: $email
    photo: $avatar
    linkedin_username: $linkedin_username
    paypal_email: $paypal_email
    donation_details: $donation_details
    biography: $biography
  }) {
    id
  }
}
`;

export default (store, index = false) => ({
  path: 'about',
  component: TopProps => {
    const Temp = compose(
      graphql(AboutUserData, {
        name: 'AboutUserData',
        options: {
          fetchPolicy: 'network-only'
        },
      }),
      graphql(SubmitAboutData, {
        name: 'SubmitAboutData',
      }),
    )(props => {
      if (props.AboutUserData.loading === false) {
        console.log('About props', props);
        return <About {...props} />;
      }
      return <Spinner />;
    });

    return <Temp {...TopProps} />;
  },
});



// WEBPACK FOOTER //
// ./src/routes/advisor/routes/Profile/routes/About/index.js